module.exports = __webpack_public_path__ + "5bc05aca.png";


//////////////////
// WEBPACK FOOTER
// ./public/images/ic_ambulance.png
// module id = 1291
// module chunks = 0 1